module.exports = __webpack_public_path__ + "img/topTitle.b1ed01b6.svg";